export var getContenidoTipoFuncionAbrirEjercicio = function getContenidoTipoFuncionAbrirEjercicio(state, zona) {
  var params = zona.vinculo.split(':')[1];

  var _params$split = params.split('.'),
      carpeta = _params$split[0],
      id = _params$split[1];

  var contenido = {
    tipo: 'funcion,abrirEjercicio',
    src: 'contenido/' + carpeta + '/ejercicio.html?id=' + id + '&curso=curso&res=res' // window.console.log("getContenidoTipoFuncionAbrirEjercicio zona, contenido", zona, contenido)

  };
  return contenido;
};